import React from 'react';
import { BlackBar, Container, Hpxp, ImagesBarHeader } from './styled.js';

export const BarHeader = () => {
  return (
    <Container>
      <ImagesBarHeader
        src="./images/headerBar.png"
        alt="HeaderBar"
      ></ImagesBarHeader>
    </Container>
  );
};
